/* Art of Curated Chic — menú lateral + aparición al hacer scroll */
(() => {
  const root = document.documentElement;
  const drawer = document.getElementById('AoccDrawer');
  const opener = document.querySelector('[data-aocc-open]');

  const close = () => {
    root.classList.remove('aocc-menu-open');
    if (opener) opener.setAttribute('aria-expanded', 'false');
  };
  const open = () => {
    root.classList.add('aocc-menu-open');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    const first = drawer && drawer.querySelector('a, button');
    if (first) first.focus();
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-aocc-open]')) open();
    else if (e.target.closest('[data-aocc-close]')) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  const els = document.querySelectorAll('.aocc-reveal');
  if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
    els.forEach((el) => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -10% 0px' });
  els.forEach((el) => io.observe(el));
})();

/* Pago rápido: usa la variante y cantidad elegidas en la ficha de producto */
document.addEventListener('submit', (e) => {
  const form = e.target.closest('[data-aocc-quickpay]');
  if (!form) return;
  const id = form.dataset.formId;
  const productForm = id && document.getElementById(id);
  const variant = productForm && productForm.querySelector('.product-variant-id');
  const qty = id && document.querySelector(`input[name="quantity"][form="${id}"]`);
  if (variant && variant.value) form.querySelector('[name="id"]').value = variant.value;
  if (qty && qty.value) form.querySelector('[name="quantity"]').value = qty.value;
});

/* Al regresar con "atrás", volver a la misma parte de la página (respaldo para Safari/iPhone) */
(() => {
  const key = 'aocc-scroll:' + location.pathname + location.search;
  const save = () => { try { sessionStorage.setItem(key, String(Math.round(window.scrollY))); } catch (e) {} };
  window.addEventListener('pagehide', save);
  document.addEventListener('click', (e) => { if (e.target.closest('a[href]')) save(); }, true);

  let nav;
  try { nav = performance.getEntriesByType('navigation')[0]; } catch (e) {}
  if (!nav || nav.type !== 'back_forward') return;
  let y = 0;
  try { y = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) {}
  if (!y) return;
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  const go = () => { if (Math.abs(window.scrollY - y) > 4) window.scrollTo(0, y); };
  go();
  requestAnimationFrame(go);
  window.addEventListener('load', () => { go(); setTimeout(go, 300); });
})();

/* Botones que se abren (VIP: Zoom y Workbook) */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-aocc-toggle]');
  if (!btn) return;
  const panel = document.getElementById(btn.getAttribute('aria-controls'));
  if (!panel) return;
  const open = btn.getAttribute('aria-expanded') !== 'true';
  btn.setAttribute('aria-expanded', String(open));
  if (open) {
    panel.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.add('is-open')));
  } else {
    panel.classList.remove('is-open');
    setTimeout(() => { if (btn.getAttribute('aria-expanded') !== 'true') panel.hidden = true; }, 500);
  }
});
